import {
  FILTER_ENABLED_SLUGS,
  PAID_FILTER_ENABLED_SLUG_OVERRIDES,
  PAID_FILTER_ENABLED_SLUG_PREFIXES,
  PAID_GEO_TARGETED_FILTER_SLUG,
} from './store/constants';
import type { FilterEnabledSlugs } from './store/types';

/**
 * Checks if a given slug is enabled for filtering on organic pages
 * @param slug - The slug to check
 * @returns True if the slug is enabled for filtering
 */
export const isFilterEnabledSlug = (slug: string): slug is FilterEnabledSlugs => {
  return FILTER_ENABLED_SLUGS.includes(slug as FilterEnabledSlugs);
};

const getPaidFilterSlugForPage = (
  slug: string,
  isGeoTargeted: boolean,
): FilterEnabledSlugs | undefined => {
  const paidSlugOverride = PAID_FILTER_ENABLED_SLUG_OVERRIDES[slug];

  if (paidSlugOverride) {
    return paidSlugOverride;
  }

  const paidPrefixFilterSlug = PAID_FILTER_ENABLED_SLUG_PREFIXES.find(({ prefix }) =>
    slug.startsWith(prefix),
  )?.filterSlug;

  if (paidPrefixFilterSlug) {
    return paidPrefixFilterSlug;
  }

  return isGeoTargeted ? PAID_GEO_TARGETED_FILTER_SLUG : undefined;
};

export const getFilterSlugForPage = (
  slug: string,
  isPaid: boolean = false,
  isGeoTargeted: boolean = false,
): FilterEnabledSlugs | undefined => {
  if (isPaid) {
    return getPaidFilterSlugForPage(slug, isGeoTargeted);
  }
  return isFilterEnabledSlug(slug) ? slug : undefined;
};
